<div class="alert-window">
    <div class="alert-header">{{ header }}</div>
    <div class="alert-message">{{ message }}</div>
    <div class="alert-button-field">
        <button *ngIf="!confirm" mat-stroked-button class="alert-button" (click)="onClose()">Ok</button>        
        <button *ngIf="confirm" mat-stroked-button class="mat-button mat-stroked-button alert-button" (click)="onConfirm(false)">Cancel</button>
        <button *ngIf="confirm" mat-stroked-button class="mat-button mat-stroked-button alert-button" (click)="onConfirm(true)">Ok</button>
    </div>
</div>